import React from 'react';

const Notice = ({ className, theme, children }) => {
    const themeClass = theme ? ` msync-notice--is-theme-${theme}` : '';
    const additionalClass = className ? ` ${className}` : '';

    return (
        <div className={`msync-notice${additionalClass}${themeClass}`}>
            <div className='msync-notice__content'>
                {children}
            </div>
        </div>
    );
};

export default Notice;